import Vue from "vue"
import Vuex from "vuex"
import user from "./modules/user"
import invoice from "./modules/invoice"
import * as types from "./mutation-types"
import * as filter from "./filters"
import { getParam, getUserAgent } from "@tencent/midas-util"
import CgiObj from "../api/cgi"
import * as reportDic from "../constants/report-dictionary"
import langs from "../constants/langs"
import Raven from "raven-js"
import * as invoiceConfig from "../constants/invoice"

Vue.use(Vuex)
filter.injectFilters()

export default new Vuex.Store({
  state: {
    sandbox: ~~getParam("sandbox"),
    pf: getParam("pf") || (getUserAgent().QQ ? reportDic.PF.QQ_RESULT : reportDic.PF.WX_RESULT),
    aid: getParam("aid"),
    appId: "1450000186",
    version: getParam("version") || "MidasInvoiceDefaultVersion1.0",
    cgiObj: null,
    toastMsg: "",
    isSpecial: getParam("_sp") == 1
  },
  getters: {
    sandbox: state => state.sandbox,
    pf: state => state.pf,
    completePf: state => {
      return `${getUserAgent().QQ ? langs.PF_SOURCE_QQ : langs.PF_SOURCE_WECHAT}-${state.pf}-html5`
    },
    appId: state => state.appId,
    cgiObj: state => state.cgiObj,
    toastMsg: state => state.toastMsg,
    isSpecial: state => state.isSpecial
  },
  actions: {
    initCgi({ commit, state, getters }) {
      // 如果是外部传入登录态，使用传入的offer_id  --- 因为之前第一次接入微信豆时他们有多个offer_id，导致配置了一个默认offer_id，
      // 所以暂时先做判断处理，后续确认是否可以去掉这个配置统一取传入的
      let appid =
        getParam("offer_id") ||
        (getters.accountType === 3 ? invoiceConfig.staticConfig && invoiceConfig.staticConfig.offer_id : state.appId)
      CgiObj.init({
        appid: appid,
        pf: getters.completePf,
        sandbox: state.sandbox,
        sessionObj: getters.sessionObj,
        version: state.version
      })
      commit(types.SET_CGI_OBJ, CgiObj.cgiObj)
    },

    updateCgi({ commit, getters }) {
      CgiObj.setSession(getters.sessionObj)
      commit(types.SET_CGI_OBJ, CgiObj.cgiObj)
    },

    setToastMsg({ commit }, { toastMsg, toastTime = 2000 }) {
      commit(types.SET_TOAST_MSG, toastMsg)
      setTimeout(() => {
        commit(types.SET_TOAST_MSG, [])
      }, toastTime)
    },

    /**
     * 上报错误到 raven.js
     * @param state
     * @param getters
     * @param err
     * @param tag
     * @param msg
     */
    reportError({ state, getters }, { err, tag, msg = {} }) {
      let extra = {
        pf: getters.completePf,
        offerId: getters.appId,
        sessionObj: getters.sessionObj,
        webVersion: state.version,
        time: new Date(),
        ...msg
      }

      Raven.captureException(err, {
        tags: { type: tag },
        extra: extra
      })
    },

    setRavenContext(msg = {}) {
      Raven.setUserContext(msg)
    }
  },
  mutations: {
    [types.SET_CGI_OBJ](state, cgiObj) {
      state.cgiObj = cgiObj
    },
    [types.SET_TOAST_MSG](state, toastMsg) {
      state.toastMsg = toastMsg
    }
  },
  modules: {
    user,
    invoice
  }
})
